import { useMutation } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { reportPaths } from '../queries/paths';

// TSS vite/03 — HTML → PDF (api-reference/admin-reports.md). The front builds
// the report HTML; the backend returns a binary PDF (Puppeteer). Response is a
// Blob (responseType: 'blob'); CSRF is added by the api interceptor.

export function useGeneratePdf() {
    return useMutation({
        mutationFn: ({ html, filename, options }) =>
            api.post(reportPaths.pdf(), { html, filename, options }, { responseType: 'blob' }).then(r => r.data),
    });
}
